import {Component, OnInit} from '@angular/core';
import {Laden} from '../../models/Laden';
import {AbcComplettApiService} from '../../services/abc-complett-api/abc-complett-api.service';
import {CookieStorageService} from '../../services/cookie-storage/cookie-storage.service';
import {EventEmitterService} from '../../services/event-emitter/event-emitter.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {

  newsObjectRoyalDonuts: Laden;
  newsObjectGewerbe: Laden;

  get cookiesAgreed(): boolean {
    return this.cookieStorage.hasAgreed;
  }

  constructor(
    private apiService: AbcComplettApiService,
    private cookieStorage: CookieStorageService,
    private eventEmitterService: EventEmitterService,
  ) {
  }

  ngOnInit() {
    this.apiService.getNewsObjectRoyalDonuts().subscribe(data => {
      this.newsObjectRoyalDonuts = data;
    });
    this.apiService.getNewsObjectGewerbe().subscribe(data => {
      this.newsObjectGewerbe = data;
    });
  }

  playbuttonClicked() {
    this.eventEmitterService.emitCookiePopup();
  }
}
